// extracted by mini-css-extract-plugin
export default {"container":"DataCollectionTable_container_fC0l6","table":"DataCollectionTable_table_udroy","spinAround":"DataCollectionTable_spinAround_gLiVC"};